import { getApiBaseUrl } from "./apiBase";

// Resolve at module load in the browser so mis-baked Bitbucket hosts (sslip.io / IPs)
// never become the live API origin. HttpHook also rewrites via resolveApiUrl.
const API_BASE = getApiBaseUrl();

export const LoginApi = `${API_BASE}users/login`;
export const LogoutApi = `${API_BASE}users/logout`;
export const GetUserByName = `${API_BASE}users/user-by-username`;
export const GetUser = `${API_BASE}users/`;
export const OrganizerEventApi = `${API_BASE}events/organizer/list`;
export const CreateBasicInfoApi = `${API_BASE}events/create`;
export const UpdateBasicInfoApi = `${API_BASE}events/updateBasicinfo/`;
export const EventById = `${API_BASE}events/getEventById/`;
export const EventDetailsApi = `${API_BASE}events/updateDetails/`;
export const RemoveImage = `${API_BASE}events/RemoveImage/`;
export const EventList = `${API_BASE}events/list`;
export const UserEventById = `${API_BASE}events/users/getEventById/`;
export const AddToWishlist = `${API_BASE}wishlist/create`;
export const RemoveFromWishlist = `${API_BASE}wishlist/delete`;
export const ListWishlist = `${API_BASE}wishlist/list`;
export const CountriesList = `${API_BASE}events/countries`;
export const CategoriesList = `${API_BASE}events/categories`;
export const refundPolicy = `${API_BASE}events/refundPolicy`;
export const updateSettings = `${API_BASE}events/settings/setting/`;
export const updInstruction = `${API_BASE}events/settings/instruction/`;
export const acceptTermsAndConditionsApi = `${API_BASE}events/acceptTermsAndConditions/`;
export const ticketTermsAndCondition = `${API_BASE}events/ticketTermsAndCondition/`;
export const createEmailSms = `${API_BASE}events/settings/createEmailSms/`;
export const deleteEmailSms = `${API_BASE}events/settings/deleteEmailSms/`;
export const GetPromocode = `${API_BASE}promocodes/`;
export const createTicketApi = `${API_BASE}events/createTicket/`;
export const deleteTicketApi = `${API_BASE}events/deleteTicketType/`;
export const CreateAddonsApi = `${API_BASE}events/addon/`;
export const GetAddonsApi = `${API_BASE}events/addons/`;
export const PublishEventApi = `${API_BASE}events/publish/`;
export const GetCart = `${API_BASE}cart/`;
export const AddToCart = `${API_BASE}cart/create`;
export const RemoveFromCart = `${API_BASE}cart/delete`;
export const ValidateCartDetails = `${API_BASE}cart/validateCart/`;
export const ApplyPromocode = `${API_BASE}promocodes/apply`;
export const RemovePromocode = `${API_BASE}promocodes/remove`;
export const AddAttendee = `${API_BASE}cart/attendee/create`;
export const DeleteAttendee = `${API_BASE}cart/attendee/delete`;
export const GetPromocodeList = `${API_BASE}promocodes`;
export const GetPromocodeActiveList = `${API_BASE}promocodes/active-promocodes`;
export const AddPromoCodeApi = `${API_BASE}promocodes/create`;
export const UpdatePromoCodeApi = `${API_BASE}promocodes`;
export const DeletePromoCodeApi = `${API_BASE}promocodes`;
export const GetPromocodeApi = `${API_BASE}promocodes`;
export const GetAllOrders = `${API_BASE}orders`;
export const OrderTag = `${API_BASE}orders/order_tag`;
export const AddbandId = `${API_BASE}orders/attendee/addBandId`;
export const GetAllOrdersForUser = `${API_BASE}orders/user/list`;
export const GetOrderDetails = `${API_BASE}orders`;
export const CancleTicketRequest = `${API_BASE}orders/ticket/cancel/request`;
export const GetTicketDetails = `${API_BASE}orders/ticket/details`;
export const DownloadTicketPdf = `${API_BASE}orders/ticket/download`;
export const GetAllAttendees = `${API_BASE}orders/attendees/list`;
export const GetAllAttendeeDetails = `${API_BASE}orders/attendee`;
export const GetInstallmentsByEvent = `${API_BASE}orders/installments/`;
export const GetOrderTransaction = `${API_BASE}orders/transactions/`;
export const CancelRemainingEmis = `${API_BASE}orders/cancel/emi`;
export const GetAllAddonsByOrderId = `${API_BASE}orders/add-ons/`;
export const GetAllCancelRequests = `${API_BASE}orders/organizer/cancel/requests`;
export const GetEventsForCalender = `${API_BASE}events/calender`;
export const GetUserCards = `${API_BASE}users/cards`;
export const AddUserCard = `${API_BASE}users/cards/add`;
export const PlaceOrder = `${API_BASE}orders`;
export const UpdateSubscriptionCard = `${API_BASE}orders/card`;
export const GetCancelRequest = `${API_BASE}orders/organizer/cancel/ticket/request`;
export const AcceptAttendeeCancelRequest = `${API_BASE}orders/organizer/accept/attendee/cancel/ticket/request`;
export const RejectAttendeeCancelRequest = `${API_BASE}orders/organizer/reject/attendee/cancel/ticket/request`;
export const RefundCancelTicket = `${API_BASE}orders/refund/payment`;
export const GetOrganizerEarningDetails = `${API_BASE}users/organizer/earning`;
export const DELETECARDS = `${API_BASE}users/cards/delete`;
export const DeleteOrder = `${API_BASE}orders`;
export const getAmountOnCancelEvent = `${API_BASE}events/amount/cancel`;
export const CancelEvent = `${API_BASE}events/cancel`;
export const GetUserEventsList = `${API_BASE}events/user/list`;
export const SendEmailTOAttendees = `${API_BASE}events/send/email/`;
export const Stepper = `${API_BASE}events/settings/stepper/`;
export const UpdateEventTiming = `${API_BASE}events/update/timing`;
export const GetEventsByDate = `${API_BASE}events/date`;
export const GetAllUserNotifications = `${API_BASE}notifications`;
export const MarkNotificationAsRead = `${API_BASE}notifications/markAsRead`;
export const MarkAllNotificationsAsRead = `${API_BASE}notifications/markAllRead`;
export const GetUserUnreadNotifications = `${API_BASE}notifications/unRead`;
export const GuardLoginApi = `${API_BASE}guards/login`;
export const GetAttendeeListForGuard = `${API_BASE}guards/attendees`;
export const MarkAttendeeCheckInOrCheckOut = `${API_BASE}guards/attendees`;
export const GetAllOrganizerEventsApi = `${API_BASE}events/organizer/events`;
export const AssignGuardToEvent = `${API_BASE}guards/register`;
export const GetEventsToGuards = `${API_BASE}guards/events`;
export const GetOrganizerGuardsList = `${API_BASE}users/organizer/guards`;
export const deletePromoter = `${API_BASE}users/delete/promoter`;
export const GetAllPromoters = `${API_BASE}users/promoters`;
export const GetAllPendingPromoters = `${API_BASE}users/promoter/list`;
export const AddPromoter = `${API_BASE}events/organizer/register/promoter`;
export const AssignPromoterToEventApi = `${API_BASE}events/organizer/assign/promoter`;
export const GetMyPromotingEventsApi = `${API_BASE}events/promoters/events`;
export const GetPomoterCommissionDetials = `${API_BASE}users/promoters/earning`;
export const GetPromoterWalletDetails = `${API_BASE}wallet`;
export const WithdrawPromoterAmount = `${API_BASE}wallet/withdraw`;
export const GetEventByTitle = `${API_BASE}events/search`;
export const GetFollowers = `${API_BASE}users/followers`;
export const RemoveExpireTicketFromCart = `${API_BASE}cart/remove/expireTicket`;
export const GetGuardById = `${API_BASE}guards`;
export const EditGuardApi = `${API_BASE}guards`;
export const ChangeGuardPassword = `${API_BASE}users/change-password`;
export const DeleteGuard = `${API_BASE}guards`;
export const OrganizerEarningDetails = `${API_BASE}users/organizer/earning`;
export const OrganizerEarningOrdersDetails = `${API_BASE}users/organizer/earning/orders`;
export const OrganizerEarningDetailsCommission = `${API_BASE}users/organizer/earning/commission`;
export const RETRIEVEPROMOCODESBYEVENTS = `${API_BASE}promocodes/promocodes-by-events`;
export const GetUsersApi = `${API_BASE}users`;
export const getOrganizerEventsByUsername = `${API_BASE}events/organizerByUsername`;
export const getUserPromotingEvents = `${API_BASE}events/getEventByPromoterUserName`;
export const AssignGuardApi = `${API_BASE}guards/assign`;
export const GetOrganizerEvents = `${API_BASE}events/organizer/list`;
export const OrganizerEarningPromoterDetails = `${API_BASE}users/organizer/earning/promoters`;
export const CheckIdMerch = `${API_BASE}users/check-id-merch`;
